import { JoyStep } from '@templates/Onboarding'

export const ONBOARDING_TITLE = 'Расскажем, как добавить или найти курс'

export const ONBOARDING_STEPS: JoyStep[] = [
  {
    target: '#add-button',
    title: 'Как добавить курс',
    content: 'Чтобы добавить курс, нажмите кнопку «Добавить»',
  },
  {
    target: '#search-block',
    title: 'Как найти курс',
    content: 'Вы можете найти нужный курс по названию',
  },
  {
    target: '#filter-panel',
    title: 'Как найти курс',
    content: 'Также можно найти курс с помощью фильтров',
  },
]
